// @ts-nocheck
import clsx from "clsx";
import { FC } from "react";
import { Row } from "react-table";
import { User } from "../../core/_models";
import { Router } from "react-router-dom";

type Props = {
  row: Row<User>;
};

const SubscriptionCustomRow: FC<Props> = ({ row }) => (
  <tr {...row.getRowProps()}>
    {row.cells.map((cell) => {
      return (
        <td
          {...cell.getCellProps()}
          key={cell.column.id}
          className={clsx("text-start", {
            "text-end min-w-100px": cell.column.id === "actions",
          })}
        >
          {cell.render("Cell")}
        </td>
      );
    })}
  </tr>
);

export { SubscriptionCustomRow };
